import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { EnvironmentService } from '../../service/service.module';

@Injectable({ providedIn: 'root' })
export class ForecastItemManagerService {
  environment = EnvironmentService.environment;

  // Subjects
  public productGridActionCellSubject: Subject<any> = new Subject();
  public productSetupActionSubject: Subject<any> = new Subject();

  /* Set Subjects for HEADER COLUMN EDIT/REMOVE */
  setProductGridActionCellSubject = (value: any) => { this.productGridActionCellSubject.next(value); };
  setProductSetupActionSubject = (value: any) => { this.productSetupActionSubject.next(value); };

  // Observables
  getProductGridActionCellSubject = () => this.productGridActionCellSubject.asObservable();
  getProductSetupActionSubject = () => this.productSetupActionSubject.asObservable();

  constructor(private http: HttpClient) {
  }

  DimItemGetList(body: any = {}) {
    return this.http.post(`${this.environment.ItemManagerForecast}/dimItemGetList`, body)
      .pipe(map(response => {
        return response;
      }));
  }

  DimItemGetById(dimItemId: any) {
    return this.http.get(`${this.environment.ItemManagerForecast}/dimItemGetById?dimItemId=${dimItemId}`)
      .pipe(map(response => {
        return response;
      }));
  }

  ProductHierarchyTreeGetList() {
    return this.http.get(`${this.environment.ItemManagerForecast}/productHierarchyForecastGetList`)
      .pipe(map(response => {
        return response;
      }));
  }

  ProductSeasonGetList() {
    return this.http.get(`${this.environment.ItemManagerForecast}/productSeasonGetList`)
      .pipe(map(response => {
        return response;
      }));
  }

  ProductSupplierGetList() {
    return this.http.get(`${this.environment.ItemManagerForecast}/productSupplierGetList`)
      .pipe(map(response => {
        return response;
      }));
  }

  ProductSourceGetList() {
    return this.http.get(`${this.environment.ItemManagerForecast}/productSourceGetList`)
      .pipe(map(response => {
        return response;
      }));
  }

  ProductUDAGetList() {
    return this.http.get(`${this.environment.ItemManagerForecast}/productUDAGetList`)
      .pipe(map(response => {
        return response;
      }));
  }

  ProductUDATypeGetList() {
    return this.http.get(`${this.environment.ItemManagerForecast}/productUDATypeGetList`)
      .pipe(map(response => {
        return response;
      }));
  }

  DeleteLikeItem(dimLikeItemId: any) {
    return this.http.delete(`${this.environment.ItemManagerForecast}/dimLikeItemDelete?dimLikeItemId=${dimLikeItemId}`)
      .pipe(map(response => {
        return response;
      }));
  }

  DeleteUDA(dimItemProductUDAId: any) {
    return this.http.delete(`${this.environment.ItemManagerForecast}/dimItemProductUDADelete?dimItemProductUDAId=${dimItemProductUDAId}`)
      .pipe(map(response => {
        return response;
      }));
  }

  ItemAdd(body: any) {
    return this.http.post(`${this.environment.ItemManagerForecast}/itemManagerForecastAdd`, body)
      .pipe(map(response => {
        return response;
      }));
  }

  ItemUpdate(body: any) {
    return this.http.post(`${this.environment.ItemManagerForecast}/itemManagerForecastUpdate`, body)
      .pipe(map(response => {
        return response;
      }));
  }

  uploadItemDocuments(docs: FormData) {
    return this.http.post(`${this.environment.ItemManagerForecast}/itemManagerForecastImagesAdd`, docs)
      .pipe(map(response => {
        return response;
      }));
  }

  deleteItemDocument(obj: any = {}) {
    return this.http.post(`${this.environment.ItemManagerForecast}/DimItemDocumentRemove`, obj)
      .pipe(map(response => {
        return response;
      }));
  }

  LikeItemGetList(node2: any = '') {
    return this.http.get(`${this.environment.ItemManagerForecast}/dimLikeItemGetList?node2=${node2}`);
  }

  ImportItemManagerTemplate(body: any) {
    return this.http.post(`${this.environment.ItemManagerForecast}/itemManagerForecastImport`, body)
      .pipe(map(data => {
        return data;
      }));
  }

}
